/* eslint-disable @next/next/no-img-element */
import React, { Fragment } from "react";

import styles from "./styles.module.scss";
import FinanceBackground from "../../public/assets/images/boi-back-2.jpg";
import BankOfIrelandLogo from "../../public/assets/icons/bank-of-ireland-logo.svg";
import EVShowBanner from "../EVShowBanner";
import { useIsBoiWebsite } from "../Context/WebsiteType";

interface IFinanceHeader {
	long?: boolean;
	hideBanner?: boolean;
}

export default function FinanceHeader({ long = false, hideBanner }: IFinanceHeader) {

	const isBoiWebsite = useIsBoiWebsite();
	return (
		<Fragment>
			<div className={`${styles.financeHeader} ${isBoiWebsite ? styles.boi : styles.nevo} ${long && `${styles.longHeader} big-header`}`} style={{ backgroundImage: `url(${FinanceBackground.src})` }}>
				<div className={styles.contentHolder}>
					<img className={styles.financeLogo} src={BankOfIrelandLogo.src} alt="Bank of Ireland Logo" />

					<div className={styles.financeContent}>
						{!long ? (
							<h1 className={styles.financeH}>Simply select the electric vehicle that is perfect for you and enquire about flexible financing below.</h1>
						) : (
							<Fragment>
								<h1 className={`${styles.longHeader} big-header`}>It&apos;s time. Go electric with flexible financing.</h1>
								<p className={styles.longDescription}>Browse & enquire vehicles available with Bank of Ireland Finance.</p>
							</Fragment>
						)}

						<p className={`${styles.financeText} small-text`}>Bank of Ireland trading as of Bank of Ireland Finance is regulated by the Central Bank of Ireland.</p>
					</div>
				</div>
			</div>

			{/* {!hideBanner && <EVShowBanner financePage staticBanner />} */}
		</Fragment>
	);
}
